import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);
gsap.set(".draw-text", { drawSVG: 0 });

const tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".draw-text",

  },
});
tl.to(".draw-text", {
  drawSVG: true,
  ease: "sine.in",
  duration: 0.4,
  stagger: {
    each: 0.3,
    from: "start",
  },
});
